import { css, cva } from '@/styled-system/css';

// The selected option row is highlighted with the soft-selected background (not greyed out like a disabled item).
export const selectedOptionRow = css.raw({ backgroundColor: '{colors.bg.action.soft.selected.default}' });

// Chip label: truncation + muted/neutral color as a static variant. Conditional token strings inline in a `css`
// prop don't get extracted by PandaCSS at build time, so the color lives in the recipe instead.
export const chipLabelRecipe = cva({
  base: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  variants: {
    muted: {
      true: { color: '{colors.text.subtle}' },
      false: { color: '{colors.text.neutral}' },
    },
  },
  defaultVariants: {
    muted: false,
  },
});

// Menu-item icon color: neutral by default; the selected radio is accent blue and destructive actions are red.
export const menuActionIconRecipe = cva({
  base: { color: '{colors.icon.neutral}' },
  variants: {
    critical: {
      true: { color: '{colors.icon.accent.red.strong}' },
      false: {},
    },
    selected: {
      true: { color: '{colors.icon.accent.blue.strong}' },
      false: {},
    },
  },
  defaultVariants: {
    critical: false,
    selected: false,
  },
});

// Bold option titles; destructive actions render red.
export const menuActionLabelRecipe = cva({
  base: { fontWeight: 700 },
  variants: {
    critical: {
      true: { color: '{colors.text.accent.red.strong}' },
      false: {},
    },
  },
  defaultVariants: {
    critical: false,
  },
});
